export * from './settings-actions'



/** WEBPACK FOOTER **
 ** ./src/actions/entities/settings/index.js
 **/